import { useMediaQuery } from '@mui/material';

import { TrapDevice } from 'api/traps/DevicesWareHouse/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { useQRCodeModalStore } from 'components/QRCodeModal/QRCodeModal';

interface Props {
  data: TrapDevice;
  isAll: boolean;
}

const TrapDeviceExpandable: React.FC<Props> = ({ data, isAll }) => {
  const { onQRCodeModalOpen } = useQRCodeModalStore();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const largeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);

  return isAll ? (
    <div className="d-flex w-100 justify-content-around border-bottom">
      {largeDesktop && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">Is used</span>
          </div>
          <div>
            {data.is_used ? (
              <div className="my-2 d-flex justify-content-start">
                <div className="text-truncate" style={{ maxWidth: '120px' }}>
                  {' '}
                  <span
                    className="badge bg-dark-subtle text-dark p-2"
                    style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    {data.is_used.site_name} | № {data.is_used.sequence_number}
                  </span>
                </div>
                <a href={`${data.is_used.detail_page_url_ending}`}>
                  <i className="ri-external-link-fill text-primary fs-16 mx-2" />
                </a>
              </div>
            ) : (
              <div>
                <span className="badge bg-danger-subtle text-danger p-2">Not in use yet</span>
              </div>
            )}
          </div>
        </div>
      )}

      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">Actions</span>
          </div>
          <div>
            <i className="ri-delete-bin-6-fill" />
            <button
              type="button"
              className="btn btn-sm btn-ghost-primary btn-icon"
              onClick={() =>
                onQRCodeModalOpen(`${process.env.REACT_APP_BASE_DJANGO_URL}${data?.qr_code}`, data?.serial_number)
              }
            >
              <i className="ri-qr-code-fill text-dark icon icon__qr-code" />
            </button>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="d-flex w-100 justify-content-around border-bottom">
      <div className="d-flex flex-column my-2">
        <div>
          <span className="me-1 fs-14 fw-bold">Model</span>
        </div>
        <div>{data.model_trap_type}</div>
      </div>
    </div>
  );
};

export default TrapDeviceExpandable;
